export default __webpack_public_path__ + "static/media/TableTales.a7e3b20f91bbc2d6c51c259cf985d0ae.webp";